import * as React from 'react'
import {Util} from 'yougile-util'
import {Padding} from '@components/common/base/design-system/types'
import {Popup as PopupNew} from '@components/common/base/popup/popup'
import {Popup} from '@components/common/popup/popup'
import {useBoolean, useGlobalKeyDown} from '@containers/hooks'
import {UIElement} from '../model/ui-element'
import {ApiElement} from './api-element'

export interface PopupProps {
  title: string
  width?: number
  subTitle?: string
  autoHeight?: boolean
  isNew?: boolean
  paddings?: Padding
  closeOnOverlayDisabled?: boolean
  /**
   * Callback on close by overlay click or escape key
   */
  onCloseBySubs?: () => void
}

export interface ApiPopupParams extends PopupProps {
  element: UIElement
}

export const ApiPopupCtl = {
  open: (_params: ApiPopupParams) => {
    //
  },
  close: () => {
    //
  }
}

export const ApiPopup = () => {
  const bem = Util.bemFrom('api-popup')
  const isOpen = useBoolean(false)
  const [isNew, setIsNew] = React.useState<boolean>(false)
  const [elem, setElem] = React.useState<UIElement | undefined>(undefined)
  const [popupProps, setPopupProps] = React.useState<PopupProps | undefined>()

  ApiPopupCtl.open = params => {
    const {element, isNew, ...rest} = params
    setElem(element)
    if (isNew !== undefined) {
      setIsNew(isNew)
    }
    setPopupProps(rest)
    isOpen.turnOn()
  }
  ApiPopupCtl.close = () => isOpen.turnOff()
  useGlobalKeyDown({
    escape: () => {
      const open = isOpen.value
      ApiPopupCtl.close()
      return open
    }
  })

  const Component = isNew ? PopupNew : Popup

  return (
    <div className={bem()}>
      {isOpen.value && (
        <Component
          close={isOpen.turnOff}
          title={popupProps?.title}
          subTitle={popupProps?.subTitle}
          width={popupProps?.width ?? 640}
          autoHeight={popupProps?.autoHeight ?? false}
          minHeightAuto={popupProps?.autoHeight ?? false}
          paddings={popupProps?.paddings}
          closeOnOverlayDisabled={popupProps?.closeOnOverlayDisabled}
          onCloseBySubs={popupProps?.onCloseBySubs}
          footer={null}
        >
          {!!elem && <ApiElement element={elem} />}
        </Component>
      )}
    </div>
  )
}
